// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import moment from "moment";
import LazyLoad from "react-lazyload";
import TextTruncate from "react-text-truncate";
import CONFIG from "../../../../config";
import { WarehouseInfo } from "../../";
import VariantsListRow from "../variantsList/variantsListRow/VariantsListRow";
import WarehouseSelect from "../warehouseSelect/WarehouseSelect";
import WarehouseBox from "../warehouseBox/WarehouseBox";
import { Modal, DatePicker, Button, Icon } from "../../../common";
import I18n from "../../../../i18n/I18n";
import Helper from "../../../../helper/Helper";
import styles from "./VariantsBox.scss";

class VariantsBox extends Component {
  constructor(props) {
    super(props);
    let sampleStocks = props.variant.stock_group;
    let aaa = [];
    if (sampleStocks) {
      for (let i = 0; i < sampleStocks.length; i++) {
        sampleStocks[i].quantity = sampleStocks[i]["stock_available"] || 0;
        sampleStocks[i].stock_updated = 0;
        sampleStocks[i].processing_time =
          !props.variant.offer_code && !sampleStocks[i].processing_time
            ? "1"
            : String(sampleStocks[i].processing_time);
        let single = sampleStocks[i];

        const abc = _.omit(single, [
          "stock_available",
          // "is_fbn",
          // "warehouse_code",
          "warehouse_priority"
        ]);

        aaa.push(abc);
        sampleStocks[i] = single;
      }
    }
    // _.remove(sampleStocks, function(currentObject) {
    //   return currentObject.is_fbn;
    // });
    this.state = {
      showWarehouse: false,
      showAddWarehouseStock: false,
      onSale: Boolean(props.variant.sale_price),
      changedVariant: {
        available_warehouses: props.variant.available_warehouses || [],
        is_active: props.is_active || props.variant.is_active || "0",
        partner_sku: props.variant.partner_sku || "",
        partner_sku_unique: props.variant.partner_sku_unique || "",
        price: props.variant.price || "",
        sale_price: props.variant.sale_price || "",
        shipping_countries: props.shipping_countries,
        id_warranty: props.id_warranty || "0",
        offer_note: props.offer_note,
        offer_code: props.variant.offer_code,
        sku: props.variant.sku,
        stocks: aaa,
        initialStocks: aaa,
        sale_end: props.variant.sale_end ? moment(props.variant.sale_end) : "",
        sale_start: props.variant.sale_start
          ? moment(props.variant.sale_start)
          : "",
        dialogOpen: false,
        percentChange: 0,
        salePercentChange: 0,
        priceError: false,
        is_partner_sku_unique: props.variant.is_partner_sku_unique
      }
    };
    this.selectedStartDate = this.selectedStartDate.bind(this);
    this.selectedEndDate = this.selectedEndDate.bind(this);
    this.inputChange = this.inputChange.bind(this);
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    const keys = [
      "shipping_countries",
      "processing_time",
      "offer_code",
      "offer_note",
      "id_warranty",
      "is_active"
    ];
    const changedVariant = this.state.changedVariant;

    for (const index in keys) {
      const key = keys[index];
      if (nextProps[key] !== this.props[key]) {
        changedVariant[key] = nextProps[key];
        this.setState(changedVariant);
        this.props.onValueChange(changedVariant);
      }
    }
  }

  openDialog = () => {
    this.setState({
      dialogOpen: true
    });
  };

  closeDialog = () => {
    this.setState({
      dialogOpen: false,
      salePercentChange: 0,
      percentChange: 0
    });
  };

  toggleShowStockUpdate = () => {
    this.setState({ showAddWarehouseStock: !this.state.showAddWarehouseStock });
  };

  toggleSale = () => {
    const newState = this.state;
    newState.onSale = !this.state.onSale;
    newState.changedVariant.sale_price = "";
    newState.changedVariant.sale_start = "";
    newState.changedVariant.sale_end = "";
    this.props.onValueChange(newState.changedVariant);
    this.setState(newState);
  };

  priceWarning = e => {
    if (e.target.name === "price" || e.target.name === "sale_price") {
      if (this.props.variant[e.target.name] && e.target.value) {
        const diff =
          Number(this.props.variant[e.target.name]) - Number(e.target.value);
        const absVal = Math.abs(diff);
        if (e.target.name === "price") {
          const percentChange = Helper.percent(
            absVal,
            Number(this.props.variant[e.target.name])
          );
          if (percentChange > 30) {
            this.setState({
              percentChange
            });
            this.openDialog();
          }
        } else {
          const salePercentChange = Helper.percent(
            absVal,
            Number(this.props.variant[e.target.name])
          );
          if (salePercentChange > 30) {
            this.setState({
              salePercentChange
            });
            this.openDialog();
          }
        }
      }
    }
  };

  resetPrice = () => {
    const newState = this.state;
    if (this.state.salePercentChange) {
      newState.changedVariant["sale_price"] = this.props.variant.sale_price;
    } else {
      newState.changedVariant["price"] = this.props.variant.price;
    }
    newState.percentChange = 0;
    newState.salePercentChange = 0;
    newState.dialogOpen = false;
    this.setState(newState);
    this.props.onValueChange(newState.changedVariant);
  };

  valAppend = val => {
    const newVar = this.state.changedVariant;
    const stocks = this.state.changedVariant.stocks;
    const match = stocks.find(
      stock => stock && val.id_warehouse === stock.id_warehouse
    );
    if (match) {
      const index = stocks.indexOf(match);
      stocks[index] = val;
    } else {
      // val.id_warehouse && val.id_warehouse!== ''
      // ? stocks.push(val) : '';
    }
    newVar.stocks = stocks;
    this.setState(newVar);
    this.props.onValueChange(newVar);
  };

  toggleWarehouse = () => {
    if (this.state.changedVariant.price) {
      this.setState({
        showWarehouse: !this.state.showWarehouse
      });
    } else {
      const changedVariant = this.state.changedVariant;
      changedVariant.priceError = true;
      this.setState(changedVariant);
    }
  };

  selectedStartDate(date) {
    const formatted = moment(date).format();
    let { sale_start, sale_end, ...rest } = this.state.changedVariant;

    if (moment(sale_end).isBefore(moment(formatted))) {
      sale_end = "";
    }

    const changedVariant = { sale_start: formatted, sale_end, ...rest };

    this.setState({
      changedVariant: changedVariant
    });
    this.props.onValueChange(changedVariant);
  }

  selectedEndDate(date) {
    const formatted = moment(date).format();
    let { sale_end, ...rest } = this.state.changedVariant;

    const changedVariant = { sale_end: formatted, ...rest };

    this.setState({
      changedVariant: changedVariant
    });
    this.props.onValueChange(changedVariant);
  }

  changeToggle() {
    let { is_active, ...rest } = this.state.changedVariant;

    const changedVariant = {
      is_active: Number(!this.state.changedVariant.is_active),
      ...rest
    };

    this.setState({
      changedVariant: changedVariant
    });
    this.props.onValueChange(changedVariant);
  }

  inputChange(e) {
    const changedVariant = this.state.changedVariant;
    changedVariant[e.target.name] = e.target.value;
    if (e.target.name === "quantity") {
      changedVariant.stock_updated =
        e.target.value !== this.props.variant.stock_available ? 1 : 0;
      changedVariant[e.target.name] = e.target.value.replace(/\D/g, "");
    }
    if (e.target.name === "price") {
      changedVariant.priceError = false;
      changedVariant.price_updated =
        e.target.value !== this.props.variant.price ? 1 : 0;
    }
    if (e.target.name === "partner_sku_unique") {
      changedVariant.partnerSkuUniqueError = false;
      changedVariant[e.target.name] = e.target.value.replace(
        /[^a-zA-Z0-9._#\-%@!^&*;:<>]/g,
        ""
      );
    }
    if (e.target.name === "price" || e.target.name === "sale_price") {
      changedVariant[e.target.name] = e.target.value.replace(/[^0-9.]/g, "");
      if (!e.target.value) {
        changedVariant.sale_start = "";
        changedVariant.sale_end = "";
      }
    }
    this.setState(changedVariant);
    this.props.onValueChange(changedVariant);
  }

  onWarehouseChange = (updateStock: Object) => {
    const changedVariant = this.state.changedVariant;

    const newStocks = changedVariant.stocks;
    if (
      newStocks &&
      typeof newStocks !== "undefined" &&
      updateStock &&
      typeof updateStock !== "undefined" &&
      updateStock !== null &&
      !_.isEmpty(updateStock)
      // && newStocks !== null &&
      // // !_.isEmpty(newStocks)
    ) {
      const match = newStocks.find(
        stock => stock && updateStock.id_warehouse === stock.id_warehouse
      );

      if (match) {
        newStocks[newStocks.indexOf(match)] = updateStock;
      } else {
        updateStock.is_new = 1;
        newStocks.push(updateStock);
      }
    }
    changedVariant.stocks = newStocks;
    //assign available warehouses to each variant
    const newVariant = changedVariant;
    if (changedVariant.stocks) {
      changedVariant.stocks.filter(stock => {
        newVariant.available_warehouses = newVariant.available_warehouses.filter(
          warehouse =>
            Number(stock.id_warehouse) !== Number(warehouse.id_warehouse)
        );
      });
    }
    changedVariant.available_warehouses = newVariant.available_warehouses;
    this.setState(changedVariant);
    this.props.onValueChange(changedVariant);
  };

  // function for copying Partner SKU to partner SKU unique
  copyValue = () => {
    const { changedVariant } = this.state;
    changedVariant.partner_sku_unique = changedVariant.partner_sku;
    this.setState(changedVariant);
    this.props.onValueChange(changedVariant);
  };

  render() {
    const variant = this.props.variant || "";
    const partnerSkuUnique = this.props.partnerSkuUnique;
    let totalStock = 0;
    if (this.state.changedVariant && this.state.changedVariant.stocks)
      for (var j = 0; j < this.state.changedVariant.stocks.length; j++) {
        totalStock += Number(this.state.changedVariant.stocks[j].quantity);
      }

    const calculatePercent = (newValue, oldValue) => {
      return newValue && newValue !== 0 ? oldValue * newValue / 100 : 0;
    };

    const percent = (amt, commission) => {
      return (
        parseFloat(amt) * parseFloat(CONFIG.SAR_CONVERSION_RATE) +
        calculatePercent(
          parseFloat(commission),
          parseFloat(amt) * parseFloat(CONFIG.SAR_CONVERSION_RATE)
        )
      );
    };
    const minimumDate = moment(this.state.changedVariant.sale_start || "");
    const sarPrice = price =>
      this.props.countryCode === "AE" &&
      Number(this.props.shipping_countries) === 3
        ? percent(price, variant.commission_rate)
        : "";

    const { offer, currencyCode, isPartnerSkuUnique, seller } = this.props;

    const warehouseAdd =
      this.state.changedVariant.available_warehouses &&
      this.state.changedVariant.available_warehouses.length ? (
        this.state.showAddWarehouseStock ? (
          <WarehouseSelect
            onWarehouseChange={this.onWarehouseChange}
            changedVariant={this.state.changedVariant}
            valAppend={this.valAppend}
            toggleShowStockUpdate={this.toggleShowStockUpdate}
          />
        ) : (
          <Button
            variant="transparent"
            className={styles.btn}
            onClick={this.toggleShowStockUpdate}
          >
            {I18n.getText("offers.add-new-stock")}
          </Button>
        )
      ) : (
        ""
      );

    const warehouseList =
      this.state.changedVariant &&
      this.state.changedVariant.stocks &&
      !_.isEmpty(this.state.changedVariant.stocks)
        ? this.state.changedVariant.stocks.map((data, index) => {
            const match = this.state.changedVariant.initialStocks.find(
              initialStock =>
                initialStock &&
                initialStock.warehouse_code === data.warehouse_code
            );
            return (
              <div className={styles.eachWh} key={index}>
                <WarehouseBox
                  data={data}
                  isFbn={this.props.isFbn}
                  offerCode={this.state.changedVariant.offer_code}
                  initialVal={match}
                  onWarehouseChange={this.onWarehouseChange}
                  valAppend={this.valAppend}
                />
              </div>
            );
          })
        : "";
    const qty =
      offer && offer.stock_available && offer.stock_reserved
        ? Number(offer.stock_available) + Number(offer.stock_reserved)
        : "";
    return (
      <div>
        {this.props.singleVariant ? (
          <VariantsListRow
            variant={variant}
            copyValue={this.copyValue}
            changedVariant={this.state.changedVariant}
            inputChange={this.inputChange}
            currencyCode={currencyCode}
            priceError={this.props.priceError}
            partnerSkuUniqueError={this.props.partnerSkuUniqueError}
            priceWarning={this.priceWarning}
            onSale={this.state.onSale}
            toggleSale={this.toggleSale}
            saleStartError={this.props.saleStartError}
            saleEndError={this.props.saleEndError}
            salePriceError={this.props.salePriceError}
            selectedStartDate={this.selectedStartDate}
            selectedEndDate={this.selectedEndDate}
            minimumDate={minimumDate}
            browser={this.props.browser}
            shipping_countries={this.props.shipping_countries}
            countryCode={this.props.countryCode}
            sarPrice={sarPrice}
            dialogOpen={this.state.dialogOpen}
            closeDialog={this.closeDialog}
            isFbn={this.props.isFbn}
            seller={seller}
            onWarehouseChange={this.onWarehouseChange}
            valAppend={this.valAppend}
            isPartnerSkuUnique={isPartnerSkuUnique}
            // partnerSkuUnique={this.state.changedVariant.partnerSkuUnique}
            showStockUpdate={this.state.showAddWarehouseStock}
            toggleShowStockUpdate={this.toggleShowStockUpdate}
          />
        ) : (
          <div className={`${styles.ctr}`}>
            <div className={styles.productWrapper}>
              <div className={styles.imageSection}>
                <div className={styles.imageNameWrapper}>
                  {I18n.getText("variants.variant")}
                  {variant && variant.variant ? (
                    <div className={styles.variant}>{variant.variant}</div>
                  ) : (
                    ""
                  )}
                </div>
                <div className={styles.dealWrapper}>
                  {variant.deal_price_sa || variant.deal_price_ae ? (
                    <h6 className={styles.attrTitle}>
                      {I18n.getText("variants.deal-price")} :
                    </h6>
                  ) : (
                    ""
                  )}
                  {variant.deal_price_sa ? (
                    <div className={styles.dealCtr}>
                      <h6 className={styles.attrTitle}>
                        {I18n.getText("variants.deal-price-sa")}
                        &nbsp;
                      </h6>
                      <div className={styles.dealPrice}>
                        {I18n.formatCurrency(
                          Helper.formatPrice(
                            sarPrice(variant.deal_price_sa),
                            "SAR"
                          ),
                          {
                            currencyClass: styles.currencyClass
                          }
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {variant.deal_price_ae ? (
                    <div className={styles.dealCtr}>
                      <h6 className={styles.attrTitle}>
                        {I18n.getText("variants.deal-price-ae")}
                        &nbsp;
                      </h6>
                      <div className={styles.dealPrice}>
                        {I18n.formatCurrency(
                          Helper.formatPrice(
                            sarPrice(variant.deal_price_ae),
                            "AED"
                          ),
                          {
                            currencyClass: styles.currencyClass
                          }
                        )}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className={styles.statusCtr}>
                  {" "}
                  <div className={styles.toggleSwitch}>
                    <input
                      className={styles.toggle}
                      type="checkbox"
                      checked={Number(this.state.changedVariant.is_active)}
                      onChange={() => this.changeToggle()}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.descCtr}>
                <div className={styles.attrCtr}>
                  <div className={styles.eachAttr}>
                    <h6 className={styles.attrTitle}>
                      {I18n.getText("variants.header-price", {}, "Price")}
                    </h6>
                    <div className={styles.attrVal}>
                      <div>
                        <div className={styles.priceWrapper}>
                          <div className={styles.currencyCode}>
                            {I18n.formatCurrency({
                              currency: currencyCode
                            })}
                          </div>
                          <input
                            type="tel"
                            disabled={seller && !seller.is_allow_price_edit}
                            value={this.state.changedVariant.price}
                            className={`${styles.priceInput} ${
                              this.props.priceError ? styles.errorInput : ""
                            }`}
                            name="price"
                            onBlur={this.priceWarning}
                            onChange={this.inputChange}
                          />
                        </div>
                        {this.props.priceError ||
                        this.state.changedVariant.priceError ? (
                          <div className={styles.error}>
                            {I18n.getText(
                              "variants.var-price-error",
                              {},
                              "Invalid Price"
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className={styles.eachAttr}>
                    <h6 className={styles.attrTitle}>
                      {I18n.getText(
                        "variants.header-sale-price",
                        {},
                        "Sale Price"
                      )}
                    </h6>
                    <div className={styles.attrVal}>
                      <div>
                        <div className={styles.priceWrapper}>
                          <div className={styles.currencyCode}>
                            {I18n.formatCurrency({
                              currency: currencyCode
                            })}
                          </div>
                          <input
                            type="tel"
                            value={this.state.changedVariant.sale_price}
                            disabled={seller && !seller.is_allow_price_edit}
                            className={styles.priceInput}
                            name="sale_price"
                            onChange={this.inputChange}
                            onBlur={this.priceWarning}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state.changedVariant.sale_price ? (
                    <div className={styles.eachAttr}>
                      <h6 className={styles.attrTitle}>
                        {I18n.getText(
                          "variants.sale-duration",
                          {},
                          "Sale Duration"
                        )}
                      </h6>
                      <div className={styles.attrVal}>
                        <div>
                          <div>
                            <div
                              className={`${styles.datePicker} ${
                                this.props.saleStartError
                                  ? styles.errorWrapper
                                  : ""
                              }`}
                            >
                              <DatePicker
                                selectedDate={this.selectedStartDate}
                                initialDate={
                                  this.state.changedVariant.sale_start
                                }
                                withPortal={
                                  !this.props.browser.greaterThan.tablet
                                }
                              />
                            </div>
                            <div
                              className={`${styles.datePicker} ${
                                this.props.saleEndError
                                  ? styles.errorWrapper
                                  : ""
                              }`}
                            >
                              <DatePicker
                                selectedDate={this.selectedEndDate}
                                withPortal={
                                  !this.props.browser.greaterThan.tablet
                                }
                                initialDate={this.state.changedVariant.sale_end}
                                clearDate={!this.state.changedVariant.sale_end}
                                isOutsideRange={day =>
                                  day.isBefore(minimumDate)
                                }
                              />
                            </div>
                          </div>
                          <div>
                            {this.props.saleStartError ||
                            this.props.saleEndError ? (
                              <div className={styles.error}>
                                {I18n.getText(
                                  "variants.date-error",
                                  {},
                                  "Choose Date"
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {this.props.variant && this.props.variant.offer_code ? (
                    <div className={styles.eachAttr}>
                      <h6 className={styles.attrTitle}>
                        {I18n.getText("variants.seller-sku", {}, "Partner SKU")}
                      </h6>
                      <div className={styles.attrVal}>
                        <div className={styles.stockWrapper}>
                          <p className={styles.arrowWrapper}>
                            <input
                              type="text"
                              value={this.state.changedVariant.partner_sku}
                              name="partner_sku"
                              className={`${styles.stockInput} ${
                                styles.skuInput
                              }`}
                              onChange={this.inputChange}
                              disabled
                            />
                            {Number(
                              this.state.changedVariant.is_partner_sku_unique
                            ) > 0 &&
                            !this.state.changedVariant.partner_sku_unique ? (
                              <div onClick={this.copyValue}>
                                <Icon
                                  name="fwd-arrow"
                                  className={styles.arrowIcon}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className={styles.eachAttr}>
                    <h6 className={styles.attrTitle}>
                      {I18n.getText(
                        "variants.seller-sku-unique",
                        {},
                        "Partner SKU unique"
                      )}
                    </h6>
                    <div className={styles.attrVal}>
                      <div className={styles.stockWrapper}>
                        <input
                          type="text"
                          value={this.state.changedVariant.partner_sku_unique}
                          name="partner_sku_unique"
                          className={`${styles.stockInput} ${styles.skuInput} ${
                            this.props.partnerSkuUniqueError
                              ? styles.errorInput
                              : ""
                          }`}
                          onChange={this.inputChange}
                        />
                        {this.props.partnerSkuUniqueError ? (
                          <div className={styles.error}>
                            {I18n.getText("variants.p-sku-unique-error")}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className={styles.eachAttr}>
                    <h6 className={styles.attrTitle}>
                      {I18n.getText("variants.warehouse-info")}
                    </h6>
                    <div className={styles.attrVal}>
                      <div
                        className={styles.editCtr}
                        onClick={this.toggleWarehouse}
                      >
                        <div className={styles.btn}>
                          {totalStock}
                          <span className={styles.edit}>
                            {I18n.getText("warehouse.edit")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.showWarehouse ? (
                  <div className={styles.whView}>
                    {warehouseList ? (
                      <div
                        className={`${styles.descCtr} ${styles.warehouseCtr}`}
                      >
                        {warehouseList}
                        {warehouseAdd}
                      </div>
                    ) : (
                      <div className={`${styles.warehouseCtr}`}>
                        {warehouseAdd}
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        )}
        <Modal
          contentLabel={"deleteConfirm"}
          isOpen={this.state.dialogOpen}
          closeModal={() => this.closeDialog()}
          dialogBox
          onSubmit={() => this.closeDialog()}
          onCancel={() => this.resetPrice()}
          cancelBtnLabel={I18n.getText("product.cancel-btn")}
          submitBtnLabel={I18n.getText("product.confirm-btn")}
          dialogTitle={I18n.getText("product.price-diff")}
        >
          <div className={styles.priceConfirm}>
            <p>
              {I18n.getText("product.pricing-change-message", {
                percent: Math.ceil(
                  this.state.percentChange || this.state.salePercentChange
                )
              })}
            </p>
            <p>
              {I18n.getText("product.pricing-confirm", {
                price: I18n.formatCurrency(
                  Helper.formatPrice(
                    this.state.salePercentChange
                      ? this.state.changedVariant.sale_price
                      : this.state.changedVariant.price,
                    currencyCode
                  )
                )
              })}
            </p>
          </div>
        </Modal>
      </div>
    );
  }
}

export default VariantsBox;



// WEBPACK FOOTER //
// ./src/components/products/offerDetails/variantsBox/VariantsBox.js